import { useEffect, useState } from "react";
import { CaretUp } from "phosphor-react";
import Pages from "./pages/index";

function App() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smoothly scrolling
    });
  };
  return (
    <>
      <Pages />
      <button
        onClick={scrollToTop}
        className={`${
          showButton ? "block" : "hidden"
        } transition-all duration-300 ease-in-out fixed z-[11] p-4 rounded-full border border-slate-100/10 bottom-4 right-4 lg:bottom-10 lg:right-10 bg-slate-900 text-white`}
      >
        <CaretUp size={24} />
      </button>
    </>
  );
}

export default App;
